<template>

	<div
		class="menu"
		v-bind:class="{
                'glossaryIsShown' : $root.states.glossaryIsShown,
                'menuIsActive' : $root.states.menuIsActive,
                'searchResultsAreShown' : $root.states.searchResultsAreShown,
                'searchResultsReferrer' : $root.states.searchResultsReferrer,
                'viewIsScrolled' : $root.states.viewIsScrolled,
                'hasVideo': $root.states.articleHasVideo
            }"
	>

		<div class="wrap">
			<div class="wrap-body">

				<div class="menu-header">
					<a href="/">
						<div class="menu-header-brand">
							#nochvielvor
						</div>
					</a>
					<button
						class="menu-header-navigation-back"
						v-on:click="navigateBack"
					>
						<span class="menu-header-navigation-back-bar"></span>
						<span class="menu-header-navigation-back-bar"></span>
					</button>
					<button
						class="menu-header-toggle"
						v-on:click="toggleContext"
					>
						<span class="header-menu-toggle-bar"></span>
						<span class="header-menu-toggle-bar"></span>
					</button>
				</div>

				<div
					class="menu-items-container"
					v-show="searchIsActive === false"
				>
					<nav class="menu-items">
						<template v-for="menuItem in menus['main-menu-primary']">
							<template v-if="menuItem._childMenuItems.length === 0">
								<a
									class="menu-item"
									:href="wpApi.stripBaseUrl(menuItem['url'])"
								>
									{{ wpApi.decodeHtmlEntityAmpersand(menuItem['title']) }}
								</a>
							</template>
							<template v-if="menuItem._childMenuItems.length > 0">
								<div class="menu-item-group">
									<div
										class="menu-item position-relative"
										v-on:click="toggleMenuItemGroup(menuItem)"
									>
										{{ wpApi.decodeHtmlEntityAmpersand(menuItem['title']) }}
									</div>
									<div class="child-menu-item-group-wrapper">
										<div
											class="child-menu-item-group clearfix"
											v-show="menuItemGroupStates[menuItem['ID']] === true"
										>
											<a
												class="child-menu-item btn btn-white-pink-black-white"
												:key="childMenuItem['ID']"
												:href="wpApi.stripBaseUrl(childMenuItem['url'])"
												v-for="childMenuItem in menuItem._childMenuItems"
											>
												{{ wpApi.decodeHtmlEntityAmpersand(childMenuItem['title']) }}
											</a>
										</div>
									</div>
								</div>
							</template>
						</template>
					</nav>
				</div>

				<div
					class="menu-search-container"
					v-show="searchIsActive"
					v-bind:style="{ fontSize : searchInputFontSizePx + 'px' }"
				>
					<div class="menu-search">
						<form v-on:submit.prevent="search">
                            <span
								class="menu-search-input-clone"
								v-bind:style="{ fontSize : searchInputFontSizePx + 'px' }"
							>{{ $root.states.searchValue }}</span>
							<span class="menu-search-input-clone-icon"></span>
							<input
								class="menu-search-input"
								placeholder="Suche"
								type="search"
								v-bind:style="{ fontSize : searchInputFontSizePx + 'px' }"
								v-model="$root.states.searchValue"
							>
							<span
								class="menu-search-input-icon"
								v-on:click="search"
								v-show="$root.states.searchValue.length"
							></span>
						</form>
					</div>
				</div>
				<tags v-show="searchIsActive" :article-primary-keyword-data="localTags" class="isScrolledIntoView "></tags>
			</div>
			<div class="wrap-footer">

				<div
					class="menu-addon-items"
					v-show="searchIsActive === false"
				>
					<div class="menu-addon-icons">
						<div
							class="menu-addon-icon"
							v-on:click="searchIsActive = !searchIsActive"
						>
							<img src="/img/ic_search_000000.svg" alt="Suche">
						</div>
						<!--<a
								href="https://www.facebook.com"
								target="_blank"
								rel="noopener"
								class="menu-addon-icon"
						>
							<img src="/img/ic_facebook_000000.svg" alt="Facebook">
						</a>
						<a
								href="https://twitter.com/"
								target="_blank"
								rel="noopener"
								class="menu-addon-icon"
						>
							<img src="/img/ic_twitter_000000.svg" alt="Twitter">
						</a>-->
					</div>

					<a
						class="menu-addon-item"
						:key="menuItem['ID']"
						:href="wpApi.stripBaseUrl(menuItem['url'])"
						v-for="menuItem in menus['main-menu-secondary']"
					>
						{{ wpApi.decodeHtmlEntityAmpersand(menuItem['title']) }}
					</a>

				</div>

			</div>
		</div>

	</div>

</template>

<script>

    // console.log('AppMenu');

    import smoothReflow from '../../../node_modules/vue-smooth-reflow/dist/vue-smooth-reflow.min';

    import cssMediaQueryHelper from '../services/cssMediaQueryHelper';
    import cssUnitHelper from '../services/cssUnitHelper';
    import wpApi from '../services/wpApi';

    import Vue from 'vue';
    import Tags from './Tags.vue';

    export default {
        props: {
            menus: {
                type: Object,
                default: () => ({})
            },
			tags: {
				type: Array,
				default: () => []
			}
        },
        mixins : [smoothReflow],
        created(){
            window.addEventListener('resize', this.resizeHandler);
        },
        destroyed(){
            window.removeEventListener('resize', this.resizeHandler);
        },
        mounted(){
            this.menuSearchElement = this.$el.querySelector('.menu-search');
            this.menuSearchInputElement = this.$el.querySelector('.menu-search-input');
            this.menuSearchInputIconElement = this.$el.querySelector('.menu-search-input-icon');
            this.menuSearchInputCloneElement = this.$el.querySelector('.menu-search-input-clone');
            this.menuSearchInputCloneIconElement = this.$el.querySelector('.menu-search-input-clone-icon');
        },
        components : {
            Tags,
        },
        computed : {
            menusData(){
                // First check if data was passed via props from PHP
                if (this.menus && Object.keys(this.menus).length > 0) {
                    return this.menus;
                }
                // Fallback to root cache for SPA compatibility
                return this.$root && this.$root.cache ? this.$root.cache.menus : {};
            },
        },
        data(){
            let fontSizeRem = 3.125;
            let minFontSizeRem = 3;
            if (cssMediaQueryHelper.watch.isPhone) {
                fontSizeRem = 2.1875;
                minFontSizeRem = 1.5;
            }
            return {
                menuItemGroupStates : {},
                menuSearchInputCloneElement : null,
                menuSearchInputCloneIconElement : null,
                menuSearchInputElement : null,
                menuSearchInputIconElement : null,
                menuSearchElement : null,
                searchInputBaseFontSizePx : cssUnitHelper.remToPx(fontSizeRem) * cssMediaQueryHelper.watch.factor,
                searchInputFontSizePx : cssUnitHelper.remToPx(fontSizeRem) * cssMediaQueryHelper.watch.factor,
                searchInputMaxFontSizePx : cssUnitHelper.remToPx(fontSizeRem) * cssMediaQueryHelper.watch.factor,
                searchInputMinFontSizePx : cssUnitHelper.remToPx(minFontSizeRem) * cssMediaQueryHelper.watch.factor,
                searchInputFontSizeModifier : 0,
                searchIsActive : false,
                windowScrollPositionPx : 0,
                localTags: [],
                wpApi,
            };
        },
        methods : {
            getThemeImageUrl(filename) {
                return '/wp-content/themes/nochvielvor-site/img/' + filename;
            },
            adjustSearchInputFontSize(){
                Vue.nextTick(()=>{
                    // console.log(
                    //     this.menuSearchInputCloneElement.offsetWidth,
                    //     this.menuSearchElement.offsetWidth,
                    //     this.searchInputFontSizeModifier
                    // );
                    if (
                        (
                            this.searchInputFontSizeModifier === 0 ||
                            this.searchInputFontSizeModifier === -1
                        ) &&
                        this.menuSearchInputCloneElement.offsetWidth > this.menuSearchElement.offsetWidth - this.searchInputFontSizePx * 3 &&
                        this.searchInputFontSizePx > this.searchInputMinFontSizePx
                    ) {
                        this.searchInputFontSizeModifier = -1;
                        this.searchInputFontSizePx += this.searchInputFontSizeModifier;
                    }
                    if (
                        (
                            this.searchInputFontSizeModifier === 0 ||
                            this.searchInputFontSizeModifier === 1
                        ) &&
                        this.menuSearchInputCloneElement.offsetWidth < this.menuSearchElement.offsetWidth - this.searchInputFontSizePx * 3 &&
                        this.searchInputFontSizePx < this.searchInputMaxFontSizePx
                    ) {
                        this.searchInputFontSizeModifier = 1;
                        this.searchInputFontSizePx += this.searchInputFontSizeModifier;
                    }
                    this.adjustSearchInputIconSizeAndPosition();
                });
            },
            adjustSearchInputIconSizeAndPosition(){
                this.menuSearchInputIconElement.style.width = this.menuSearchInputCloneIconElement.offsetWidth + 'px';
                this.menuSearchInputIconElement.style.height = this.menuSearchInputCloneIconElement.offsetHeight + 'px';
                this.menuSearchInputIconElement.style.left = this.menuSearchInputCloneIconElement.offsetLeft + 'px';
            },
            navigateBack(){
                if (this.$root.states.searchResultsReferrer) {
                    this.$router.push(this.$root.states.searchResultsReferrer);
                    this.$root.states.searchResultsReferrer = null;
                }
            },
            resizeHandler(){
                let fontSizeRem = 3.125;
                let minFontSizeRem = 3;
                if (cssMediaQueryHelper.watch.isPhone) {
                    fontSizeRem = 2.1875;
                    minFontSizeRem = 1.5;
                }
                this.searchInputBaseFontSizePx = cssUnitHelper.remToPx(fontSizeRem) * cssMediaQueryHelper.watch.factor;
                this.searchInputFontSizePx = cssUnitHelper.remToPx(fontSizeRem) * cssMediaQueryHelper.watch.factor;
                this.searchInputMaxFontSizePx = cssUnitHelper.remToPx(fontSizeRem) * cssMediaQueryHelper.watch.factor;
                this.searchInputMinFontSizePx = cssUnitHelper.remToPx(minFontSizeRem) * cssMediaQueryHelper.watch.factor;
                this.searchInputFontSizeModifier = 0;
                this.searchInputFontSizePx = this.searchInputBaseFontSizePx;
            },
            search(){
				if (!this.$root.states.searchValue || this.$root.states.searchValue.trim() === '') {
					return; // Don't search if empty
				}

				this.$root.states.searchResultsReferrer = window.location.pathname;
				const searchTerm = this.$root.states.searchValue.toLowerCase().trim();

				// Use WordPress search with custom URL
				window.location.href = `/suche/${encodeURIComponent(searchTerm)}`;
            },
            openMenu(){
                console.log('openMenu');
                this.windowScrollPositionPx = window.pageYOffset;
                this.$root.$el.style.top = -this.windowScrollPositionPx + 'px';
                this.$root.$el.style.position = 'fixed';
            },
            closeMenu(){
                this.menuItemGroupStates = {};
                this.$root.states.searchValue = '';
                this.$root.$el.style.position = 'relative';
                this.$root.$el.style.top = 'auto';
                window.scrollTo(0, this.windowScrollPositionPx);
            },
            toggleContext(){
                if (
                    this.$root.states.searchResultsAreShown &&
                    this.$root.states.menuIsActive === false &&
                    this.searchIsActive === false
                ) {
                    this.$root.states.menuIsActive = true;
                    this.searchIsActive = true;
                    this.$root.states.searchValue = this.$root.states.previousSearchValue;
                    return;
                }
                if (
                    this.$root.states.menuIsActive &&
                    this.searchIsActive
                ) {
                    this.searchIsActive = false;
                    this.$root.states.searchValue = '';
                    return;
                }
                this.$root.states.menuIsActive = !this.$root.states.menuIsActive;
            },
            toggleMenuItemGroup(menuItem){
                var isActive = this.menuItemGroupStates[menuItem['ID']] != 'undefined' ? !this.menuItemGroupStates[menuItem['ID']] : true;
                this.menuItemGroupStates = {};
                this.$set(this.menuItemGroupStates, menuItem['ID'], isActive);
            },
        },
        watch : {
            $route(to, from){
                this.searchIsActive = false;
                this.$root.states.menuIsActive = false;
                if (this.$route.name !== 'glossary') {
                    this.$root.states.glossaryIsShown = false;
                }
                if (this.$route.name !== 'search') {
                    this.$root.states.searchResultsAreShown = false;
                    this.$root.states.searchResultsReferrer = null;
                }
            },
            menusData: {
                handler(value){
                    if (value && value['main-menu-primary']) {
                        window.setTimeout(()=>{
                            if (typeof $ !== 'undefined') {
                                $('.child-menu-item-group-wrapper').each((index, element)=>{
                                    this.$smoothReflow({
                                        el : element,
                                        transition : 'height 800ms cubic-bezier(0.680, -0.550, 0.265, 1.550)',
                                    });
                                });
                            }
                        });
                    }
                },
                deep: true,
                immediate: true
            },
            '$root.states.menuIsActive'(value){
                if (value) {
                    this.openMenu();
                } else {
                    this.closeMenu();
                }
            },
            '$root.states.searchValue'(value){
                this.searchInputFontSizeModifier = 0;
                this.adjustSearchInputFontSize();
            },
            searchIsActive(value){
                if (value) {
                    Vue.nextTick(()=>{
                        console.log('searchIsActive');
                        this.resizeHandler();
                        this.adjustSearchInputFontSize();
                        this.menuSearchInputElement.focus();

						if (this.tags && this.tags.length > 0) {
							this.localTags = this.tags;
						}
                    });
                }
            },
            searchInputFontSizePx(value){
                this.adjustSearchInputFontSize();
            },
        },
    }

</script>

<style lang="scss">

    @import '../../css/variables';

    .menu {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 5.5rem;
        overflow: hidden;
        background-color: transparent;
        transition: background-color 400ms, height 400ms;
        will-change: background-color, height;
        z-index: 1000;
        @media screen and (max-width: 767px) {
            height: 5.5rem * $factor-720;
        }
        @media screen and (min-width: 1200px) {
            height: 5.5rem * $factor-1200;
        }
        @media screen and (min-width: 1440px) {
            height: 5.5rem * $factor-1440;
        }
        @media screen and (min-width: 1920px) {
            height: 5.5rem * $factor-1920;
        }
        @media screen and (min-width: 2400px) {
            height: 5.5rem * $factor-2400;
        }
        &.viewIsScrolled:not(.menuIsActive) {
            background-color: transparentize($color-nochvielvor-black, 0.12);
            height: 3.5rem;
            @media screen and (max-width: 767px) {
                height: 3.5rem * $factor-720;
            }
            @media screen and (min-width: 1200px) {
                height: 3.5rem * $factor-1200;
            }
            @media screen and (min-width: 1440px) {
                height: 3.5rem * $factor-1440;
            }
            @media screen and (min-width: 1920px) {
                height: 3.5rem * $factor-1920;
            }
            @media screen and (min-width: 2400px) {
                height: 3.5rem * $factor-2400;
            }
            .menu-header {
                .menu-header-brand {
                    margin-top: 1rem;
                    color: $color-nochvielvor-white;
                    @media screen and (max-width: 767px) {
                        margin-top: 1rem * $factor-720;
                    }
                    @media screen and (min-width: 1200px) {
                        margin-top: 1rem * $factor-1200;
                    }
                    @media screen and (min-width: 1440px) {
                        margin-top: 1rem * $factor-1440;
                    }
                    @media screen and (min-width: 1920px) {
                        margin-top: 1rem * $factor-1920;
                    }
                    @media screen and (min-width: 2400px) {
                        margin-top: 1rem * $factor-2400;
                    }
                }
                .menu-header-navigation-back {
                    width: 2.5rem;
                    height: 3.5rem;
                    @media screen and (max-width: 767px) {
                        width: 2.5rem * $factor-720;
                        height: 3.5rem * $factor-720;
                    }
                    @media screen and (min-width: 1200px) {
                        width: 2.5rem * $factor-1200;
                        height: 3.5rem * $factor-1200;
                    }
                    @media screen and (min-width: 1440px) {
                        width: 2.5rem * $factor-1440;
                        height: 3.5rem * $factor-1440;
                    }
                    @media screen and (min-width: 1920px) {
                        width: 2.5rem * $factor-1920;
                        height: 3.5rem * $factor-1920;
                    }
                    @media screen and (min-width: 2400px) {
                        width: 2.5rem * $factor-2400;
                        height: 3.5rem * $factor-2400;
                    }
                    .menu-header-navigation-back-bar {
                        background-color: $color-nochvielvor-white;
                    }
                }
                .menu-header-toggle {
                    width: 5.5rem;
                    height: 3.5rem;
                    @media screen and (max-width: 767px) {
                        width: 5.5rem * $factor-720;
                        height: 3.5rem * $factor-720;
                    }
                    @media screen and (min-width: 1200px) {
                        width: 5.5rem * $factor-1200;
                        height: 3.5rem * $factor-1200;
                    }
                    @media screen and (min-width: 1440px) {
                        width: 5.5rem * $factor-1440;
                        height: 3.5rem * $factor-1440;
                    }
                    @media screen and (min-width: 1920px) {
                        width: 5.5rem * $factor-1920;
                        height: 3.5rem * $factor-1920;
                    }
                    @media screen and (min-width: 2400px) {
                        width: 5.5rem * $factor-2400;
                        height: 3.5rem * $factor-2400;
                    }
                    .header-menu-toggle-bar {
                        background-color: $color-nochvielvor-white;
                    }
                }
            }
        }
        &.menuIsActive {
            height: 100%;
            overflow-y: scroll;
            overscroll-behavior: contain;
            -webkit-overflow-scrolling: touch;
            background-color: transparentize($color-nochvielvor-pink, 0.04);
            .menu-header {
                .menu-header-brand {
                    color: $color-nochvielvor-white;
                }
                .menu-header-toggle {
                    .header-menu-toggle-bar {
                        background-color: $color-nochvielvor-white;
                        &:first-child {
                            margin-bottom: 0;
                            transform: rotate(-45deg) translateY(50%);
                        }
                        &:last-child {
                            transform: rotate(45deg) translateY(-50%);
                        }
                    }
                }
            }
            .menu-items-container {
                .menu-items {
                    .menu-item {
                        opacity: 1;
                        transition: opacity 800ms;
                    }
                }
            }
            .menu-addon-items {
                .menu-addon-item {
                    opacity: 1;
                    transition: opacity 800ms;
                }
                .menu-addon-icons {
                    .menu-addon-icon {
                        opacity: 1;
                        transition: opacity 800ms;
                    }
                }
            }
            .menu-search-container {
                .menu-search {
                    opacity: 1;
                    transition: opacity 1000ms 800ms;
                }
            }
        }
        &.menuIsActive.searchResultsAreShown.searchResultsReferrer {
            .menu-header-navigation-back {
                display: block;
                .menu-header-navigation-back-bar {
                    background-color: $color-nochvielvor-white;
                }
            }
        }
        &.glossaryIsShown,
        &.searchResultsAreShown,
        &.searchResultsReferrer {
            .menu-header {
                .menu-header-toggle {
                    .header-menu-toggle-bar {
                        &:first-child {
                            margin-bottom: 0;
                            transform: rotate(-45deg) translateY(50%);
                        }
                        &:last-child {
                            transform: rotate(45deg) translateY(-50%);
                        }
                    }
                }
            }
        }
        &.hasVideo .menu-header {
            .menu-header-brand{
                margin-top: 3rem;
                @media screen and (min-width: 1200px) {
                    margin-top: 3rem * $factor-1200;
                }
                @media screen and (min-width: 1440px) {
                    margin-top: 3rem * $factor-1440;
                }
                @media screen and (min-width: 1920px) {
                    margin-top: 3rem * $factor-1920;
                }
                @media screen and (min-width: 2400px) {
                    margin-top: 3rem * $factor-2400;
                }
            }
            .menu-header-toggle {
                height: 7.125rem;
                @media screen and (min-width: 1200px) {
                    height: 7.625rem * $factor-1200;
                }
                @media screen and (min-width: 1440px) {
                    height: 7.625rem * $factor-1440;
                }
                @media screen and (min-width: 1920px) {
                    height: 7.625rem * $factor-1920;
                }
                @media screen and (min-width: 2400px) {
                    height: 7.625rem * $factor-2400;
                }
            }
        }
        a {
            text-decoration: none;
        }
        .menu-header {
			a:hover, a:focus {
				text-decoration:none;
			}
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            .menu-header-brand {
                margin-top: 2rem;
                margin-left: 1.5rem;
                color: $color-nochvielvor-pink;
                font-size: 1.5rem;
                font-weight: bold;
                line-height: 1;
                text-transform: uppercase;
                transition: margin-top 400ms, color 400ms;
                will-change: margin-top, color;
                @media screen and (max-width: 767px) {
                    margin-top: 2rem * $factor-720;
                    font-size: 1.5rem * $factor-720;
                }
                @media screen and (min-width: 1200px) {
                    margin-left: 1.5rem * $factor-1200;
                    margin-top: 2rem * $factor-1200;
                    font-size: 1.5rem * $factor-1200;
                }
                @media screen and (min-width: 1440px) {
                    margin-left: 1.5rem * $factor-1440;
                    margin-top: 2rem * $factor-1440;
                    font-size: 1.5rem * $factor-1440;
                }
                @media screen and (min-width: 1920px) {
                    margin-left: 1.5rem * $factor-1920;
                    margin-top: 2rem * $factor-1920;
                    font-size: 1.5rem * $factor-1920;
                }
                @media screen and (min-width: 2400px) {
                    margin-left: 1.5rem * $factor-2400;
                    margin-top: 2rem * $factor-2400;
                    font-size: 1.5rem * $factor-2400;
                }
            }
            .menu-header-navigation-back {
                display: none;
                position: relative;
                width: 2.5rem;
                height: 5.5rem;
                padding: 0;
                margin: 0 0 0 auto;
                background-color: transparent;
                border: 0 none;
                cursor: pointer;
                transition: height 400ms;
                will-change: height;
                @media screen and (max-width: 767px) {
                    width: 2.5rem * $factor-720;
                    height: 5.5rem * $factor-720;
                }
                @media screen and (min-width: 1200px) {
                    width: 2.5rem * $factor-1200;
                    height: 5.5rem * $factor-1200;
                }
                @media screen and (min-width: 1440px) {
                    width: 2.5rem * $factor-1440;
                    height: 5.5rem * $factor-1440;
                }
                @media screen and (min-width: 1920px) {
                    width: 2.5rem * $factor-1920;
                    height: 5.5rem * $factor-1920;
                }
                @media screen and (min-width: 2400px) {
                    width: 2.5rem * $factor-2400;
                    height: 5.5rem * $factor-2400;
                }
                &:focus {
                    outline: none;
                }
                .menu-header-navigation-back-bar {
                    position: absolute;
                    display: block;
                    left: 50%;
                    top: 50%;
                    width: 1.25rem;
                    height: 0.375rem;
                    background-color: $color-nochvielvor-pink;
                    transition: background-color 400ms, margin-bottom 200ms cubic-bezier(0.680, -0.550, 0.265, 1.550), transform 200ms cubic-bezier(0.680, -0.550, 0.265, 1.550);
                    will-change: background-color, margin-bottom, transform;
                    @media screen and (max-width: 767px) {
                        width: 1.25rem * $factor-720;
                        height: 0.375rem * $factor-720;
                    }
                    @media screen and (min-width: 1200px) {
                        width: 1.25rem * $factor-1200;
                        height: 0.375rem * $factor-1200;
                    }
                    @media screen and (min-width: 1440px) {
                        width: 1.25rem * $factor-1440;
                        height: 0.375rem * $factor-1440;
                    }
                    @media screen and (min-width: 1920px) {
                        width: 1.25rem * $factor-1920;
                        height: 0.375rem * $factor-1920;
                    }
                    @media screen and (min-width: 2400px) {
                        width: 1.25rem * $factor-2400;
                        height: 0.375rem * $factor-2400;
                    }
                    &:first-child {
                        transform: translateY(-50%) rotate(45deg) translateX(-0.1875rem);
                        transform-origin: 0 50%;
                        @media screen and (max-width: 767px) {
                            transform: translateY(-50%) rotate(45deg) translateX(-0.1875rem * $factor-720);
                        }
                        @media screen and (min-width: 1200px) {
                            transform: translateY(-50%) rotate(45deg) translateX(-0.1875rem * $factor-1200);
                        }
                        @media screen and (min-width: 1440px) {
                            transform: translateY(-50%) rotate(45deg) translateX(-0.1875rem * $factor-1440);
                        }
                        @media screen and (min-width: 1920px) {
                            transform: translateY(-50%) rotate(45deg) translateX(-0.1875rem * $factor-1920);
                        }
                        @media screen and (min-width: 2400px) {
                            transform: translateY(-50%) rotate(45deg) translateX(-0.1875rem * $factor-2400);
                        }
                    }
                    &:last-child {
                        transform: translateY(-50%) rotate(-45deg) translateX(-0.1875rem);
                        transform-origin: 0 50%;
                        @media screen and (max-width: 767px) {
                            transform: translateY(-50%) rotate(-45deg) translateX(-0.1875rem * $factor-720);
                        }
                        @media screen and (min-width: 1200px) {
                            transform: translateY(-50%) rotate(-45deg) translateX(-0.1875rem * $factor-1200);
                        }
                        @media screen and (min-width: 1440px) {
                            transform: translateY(-50%) rotate(-45deg) translateX(-0.1875rem * $factor-1440);
                        }
                        @media screen and (min-width: 1920px) {
                            transform: translateY(-50%) rotate(-45deg) translateX(-0.1875rem * $factor-1920);
                        }
                        @media screen and (min-width: 2400px) {
                            transform: translateY(-50%) rotate(-45deg) translateX(-0.1875rem * $factor-2400);
                        }
                    }
                }
            }
            .menu-header-toggle {
                position: relative;
                width: 5.5rem;
                height: 5.5rem;
                padding-left: 1.625rem;
                padding-right: 1.625rem;
                background-color: transparent;
                border: 0 none;
                cursor: pointer;
                transition: height 400ms;
                will-change: height;
                @media screen and (max-width: 767px) {
                    width: 5.5rem * $factor-720;
                    height: 5.5rem * $factor-720;
                    padding-left: 1.625rem * $factor-720;
                    padding-right: 1.625rem * $factor-720;
                    background-size: 1.875rem * $factor-720 1.875rem * $factor-720;
                }
                @media screen and (min-width: 1200px) {
                    width: 5.5rem * $factor-1200;
                    height: 5.5rem * $factor-1200;
                    padding-left: 1.625rem * $factor-1200;
                    padding-right: 1.625rem * $factor-1200;
                    background-size: 1.875rem * $factor-1200 1.875rem * $factor-1200;
                }
                @media screen and (min-width: 1440px) {
                    width: 5.5rem * $factor-1440;
                    height: 5.5rem * $factor-1440;
                    padding-left: 1.625rem * $factor-1440;
                    padding-right: 1.625rem * $factor-1440;
                    background-size: 1.875rem * $factor-1440 1.875rem * $factor-1440;
                }
                @media screen and (min-width: 1920px) {
                    width: 5.5rem * $factor-1920;
                    height: 5.5rem * $factor-1920;
                    padding-left: 1.625rem * $factor-1920;
                    padding-right: 1.625rem * $factor-1920;
                    background-size: 1.875rem * $factor-1920 1.875rem * $factor-1920;
                }
                @media screen and (min-width: 2400px) {
                    width: 5.5rem * $factor-2400;
                    height: 5.5rem * $factor-2400;
                    padding-left: 1.625rem * $factor-2400;
                    padding-right: 1.625rem * $factor-2400;
                    background-size: 1.875rem * $factor-2400 1.875rem * $factor-2400;
                }
                &:focus {
                    outline: none;
                }
                .header-menu-toggle-bar {
                    display: block;
                    width: 2.25rem;
                    height: 0.375rem;
                    background-color: $color-nochvielvor-pink;
                    transition: background-color 400ms, margin-bottom 200ms cubic-bezier(0.680, -0.550, 0.265, 1.550), transform 200ms cubic-bezier(0.680, -0.550, 0.265, 1.550);
                    will-change: background-color, margin-bottom, transform;
                    @media screen and (max-width: 767px) {
                        width: 2.25rem * $factor-720;
                        height: 0.375rem * $factor-720;
                    }
                    @media screen and (min-width: 1200px) {
                        width: 2.25rem * $factor-1200;
                        height: 0.375rem * $factor-1200;
                    }
                    @media screen and (min-width: 1440px) {
                        width: 2.25rem * $factor-1440;
                        height: 0.375rem * $factor-1440;
                    }
                    @media screen and (min-width: 1920px) {
                        width: 2.25rem * $factor-1920;
                        height: 0.375rem * $factor-1920;
                    }
                    @media screen and (min-width: 2400px) {
                        width: 2.25rem * $factor-2400;
                        height: 0.375rem * $factor-2400;
                    }
                    &:first-child {
                        transform-origin: 50% 100%;
                        margin-bottom: 0.1875rem;
                        @media screen and (max-width: 767px) {
                            margin-bottom: 0.1875rem * $factor-720;
                        }
                        @media screen and (min-width: 1200px) {
                            margin-bottom: 0.1875rem * $factor-1200;
                        }
                        @media screen and (min-width: 1440px) {
                            margin-bottom: 0.1875rem * $factor-1440;
                        }
                        @media screen and (min-width: 1920px) {
                            margin-bottom: 0.1875rem * $factor-1920;
                        }
                        @media screen and (min-width: 2400px) {
                            margin-bottom: 0.1875rem * $factor-2400;
                        }
                    }
                    &:last-child {
                        transform-origin: 50% 0;
                    }
                }
            }
        }
        .menu-items-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            flex: 1 0 auto;
            @media screen and (max-width: 767px) {
                display: block;
                padding: 1.5rem 1.5rem 0 1.5rem;
            }
            .menu-items {
                width: 50%;
                @media screen and (max-width: 767px) {
                    position: relative;
                    left: auto;
                    top: auto;
                    width: 100%;
                    transform: none;
                }
                .menu-item {
                    display: block;
                    color: $color-nochvielvor-white;
                    cursor: pointer;
                    font-size: 1.5rem;
                    font-weight: bold;
                    line-height: 1.5;
                    opacity: 0;
                    text-decoration: none;
                    text-transform: uppercase;
                    transition: none;
                    will-change: opacity;
                    @media screen and (max-width: 767px) {
                        margin-bottom: 1rem;
                        font-size: 1.5rem * $factor-720;
                        line-height: 1.2;
                    }
                    @media screen and (min-width: 1200px) {
                        font-size: 1.5rem * $factor-1200;
                    }
                    @media screen and (min-width: 1440px) {
                        font-size: 1.5rem * $factor-1440;
                    }
                    @media screen and (min-width: 1920px) {
                        font-size: 1.5rem * $factor-1920;
                    }
                    @media screen and (min-width: 2400px) {
                        font-size: 1.5rem * $factor-2400;
                    }
                    @for $i from 1 through 20 {
                        &:nth-child(#{$i}) {
                            transition-delay: #{$i * 50 + 400}ms;
                        }
                    }
                    &:last-child {
                        margin-bottom: 0;
                    }
                }
                .menu-item-group {
                }
                .child-menu-item {
                    display: block;
                    margin: 0 0.5rem 0.5rem 0;
                    text-align: left;
                    float: left;
                    white-space: normal;
                    clear: both;
                    @media screen and (min-width: 1200px) {
                        margin: 0 0.5rem * $factor-1200 0.5rem * $factor-1200 0;
                    }
                    @media screen and (min-width: 1440px) {
                        margin: 0 0.5rem * $factor-1440 0.5rem * $factor-1440 0;
                    }
                    @media screen and (min-width: 1920px) {
                        margin: 0 0.5rem * $factor-1920 0.5rem * $factor-1920 0;
                    }
                    @media screen and (min-width: 2400px) {
                        margin: 0 0.5rem * $factor-2400 0.5rem * $factor-2400 0;
                    }
                }
                .child-menu-item-group {
                    padding: 0.5rem 0 1rem 0;
                    @media screen and (min-width: 1200px) {
                        padding: 0.5rem * $factor-1200 0 1rem * $factor-1200 0;
                    }
                    @media screen and (min-width: 1440px) {
                        padding: 0.5rem * $factor-1440 0 1rem * $factor-1440 0;
                    }
                    @media screen and (min-width: 1920px) {
                        padding: 0.5rem * $factor-1920 0 1rem * $factor-1920 0;
                    }
                    @media screen and (min-width: 2400px) {
                        padding: 0.5rem * $factor-2400 0 1rem * $factor-2400 0;
                    }
                }
            }
        }
        .menu-addon-items {
            padding-right: 1.5rem;
            padding-bottom: 1.5rem;
            @media screen and (min-width: 1200px) {
                padding-right: 1.5rem * $factor-1200;
                padding-bottom: 1.5rem * $factor-1200;
            }
            @media screen and (min-width: 1440px) {
                padding-right: 1.5rem * $factor-1440;
                padding-bottom: 1.5rem * $factor-1440;
            }
            @media screen and (min-width: 1920px) {
                padding-right: 1.5rem * $factor-1920;
                padding-bottom: 1.5rem * $factor-1920;
            }
            @media screen and (min-width: 2400px) {
                padding-right: 1.5rem * $factor-2400;
                padding-bottom: 1.5rem * $factor-2400;
            }
            .menu-addon-item {
                display: block;
                color: $color-nochvielvor-black;
                font-size: 1rem;
                font-weight: 500;
                line-height: 1.5;
                opacity: 0;
                text-align: right;
                text-decoration: none;
                transition: none;
                will-change: opacity;
                @media screen and (min-width: 1200px) {
                    font-size: 1rem * $factor-1200;
                }
                @media screen and (min-width: 1440px) {
                    font-size: 1rem * $factor-1440;
                }
                @media screen and (min-width: 1920px) {
                    font-size: 1rem * $factor-1920;
                }
                @media screen and (min-width: 2400px) {
                    font-size: 1rem * $factor-2400;
                }
                @for $i from 1 through 20 {
                    &:nth-child(#{$i}) {
                        transition-delay: #{$i * 50 + 800}ms;
                    }
                }
            }
            .menu-addon-icons {
                padding-bottom: 1rem;
                @media screen and (min-width: 1200px) {
                    padding-bottom: 1rem * $factor-1200;
                }
                @media screen and (min-width: 1440px) {
                    padding-bottom: 1rem * $factor-1440;
                }
                @media screen and (min-width: 1920px) {
                    padding-bottom: 1rem * $factor-1920;
                }
                @media screen and (min-width: 2400px) {
                    padding-bottom: 1rem * $factor-2400;
                }
                .menu-addon-icon {
                    display: block;
                    width: 2rem;
                    height: 2rem;
                    margin-left: auto;
                    margin-bottom: 0.5rem;
                    cursor: pointer;
                    opacity: 0;
                    transition: none;
                    will-change: opacity;
                    @media screen and (min-width: 1200px) {
                        width: 2rem * $factor-1200;
                        height: 2rem * $factor-1200;
                        margin-bottom: 0.5rem * $factor-1200;
                    }
                    @media screen and (min-width: 1440px) {
                        width: 2rem * $factor-1440;
                        height: 2rem * $factor-1440;
                        margin-bottom: 0.5rem * $factor-1440;
                    }
                    @media screen and (min-width: 1920px) {
                        width: 2rem * $factor-1920;
                        height: 2rem * $factor-1920;
                        margin-bottom: 0.5rem * $factor-1920;
                    }
                    @media screen and (min-width: 2400px) {
                        width: 2rem * $factor-2400;
                        height: 2rem * $factor-2400;
                        margin-bottom: 0.5rem * $factor-2400;
                    }
                    @for $i from 1 through 20 {
                        &:nth-child(#{$i}) {
                            transition-delay: #{$i * 50 + 800}ms;
                        }
                    }
                    img {
                        width: 100%;
                        height: auto;
                    }
                }
            }
        }
        .menu-search-container {
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            flex: 0.6 0 auto;
            min-height: calc(1em * 1.2);
            font-size: 2.1875rem;
            margin-bottom: 40px;
            @media screen and (min-width: 768px) {
                font-size: 3.125rem;
                margin-bottom: 80px;
            }
            /*@media screen and (min-width: 1200px) {
                font-size: 6.25rem * $factor-1200;
            }
            @media screen and (min-width: 1440px) {
                font-size: 6.25rem * $factor-1440;
            }
            @media screen and (min-width: 1920px) {
                font-size: 6.25rem * $factor-1920;
            }
            @media screen and (min-width: 2400px) {
                font-size: 6.25rem * $factor-2400;
            }*/
            .menu-search {
                position: relative;
                width: 100%;
                height: 70px;
                max-width: 100%;
                line-height: 1;
                opacity: 0;
                transition: none;
                will-change: opacity;
                .menu-search-input {
                    display: block;
                    position: absolute;
                    left: 1.5rem;
                    top: 0;
                    width: calc(100% - 1.5em - 1.5rem - 1.5rem);
                    //height: 42px;
                    padding: 0;
                    background-color: transparent;
                    border: 0 none;
                    caret-color: $color-nochvielvor-white;
                    color: $color-nochvielvor-white;
                    font-size: 2.1875rem;
                    font-weight: bold;
                    //line-height: 1.2;
                    text-transform: uppercase;
                    /* clears the ‘X’ from Internet Explorer */
                    &::-ms-clear { display: none; width : 0; height: 0; }
                    &::-ms-reveal { display: none; width : 0; height: 0; }
                    /* clears the ‘X’ from Chrome */
                    &::-webkit-search-decoration,
                    &::-webkit-search-cancel-button,
                    &::-webkit-search-results-button,
                    &::-webkit-search-results-decoration { display: none; }
                    /*@media screen and (max-width: 767px) {
                        font-size: 3.125rem;
                    }*/
                    @media screen and (min-width: 768px) {
                        font-size: 3.125rem;
                        //height: 60px;
                        //line-height: 2.5;
                    }
                    @media screen and (min-width: 1200px) {
                        left: 1.5rem * $factor-1200;
                        width: calc(100% - 1.5em - 1.5rem * #{$factor-1200} - 1.5rem * #{$factor-1200});
                        //font-size: 6.25rem * $factor-1200;
                    }
                    @media screen and (min-width: 1440px) {
                        left: 1.5rem * $factor-1440;
                        width: calc(100% - 1.5em - 1.5rem * #{$factor-1440} - 1.5rem * #{$factor-1440});
                        //font-size: 6.25rem * $factor-1440;
                    }
                    @media screen and (min-width: 1920px) {
                        left: 1.5rem * $factor-1920;
                        width: calc(100% - 1.5em - 1.5rem * #{$factor-1920} - 1.5rem * #{$factor-1920});
                        //font-size: 6.25rem * $factor-1920;
                    }
                    @media screen and (min-width: 2400px) {
                        left: 1.5rem * $factor-2400;
                        width: calc(100% - 1.5em - 1.5rem * #{$factor-2400} - 1.5rem * #{$factor-2400});
                        //font-size: 6.25rem * $factor-2400;
                    }
                    &::-webkit-input-placeholder {
                        color: $color-nochvielvor-white;
                    }
                    &::-moz-placeholder {
                        color: $color-nochvielvor-white;
                    }
                    &:-ms-input-placeholder {
                        color: $color-nochvielvor-white;
                    }
                    &::-ms-clear {
                        width: 0;
                        height: 0;
                    }
                    &:focus {
                        outline: none;
                    }
                }
                .menu-search-input-icon {
                    position: absolute;
                    left: 0;
                    top: 0;
                    cursor: pointer;
                    background-image: url(/wp-content/themes/nochvielvor-site/img/ic_search_ffffff.svg);
                    background-repeat: no-repeat;
                    background-position: 50% 50%;
                    background-size: 100% 100%;
                    height: 42px;
                    width: 45px;
                    @media screen and (min-width: 768px) {
                        height: 70px;
                        width: 65px;
                    }
                }
                .menu-search-input-clone {
                    display: inline-block;
                    margin-left: 1.5rem;
                    height: 42px;
                    max-width: calc(100% - 1.5em - 1.5rem - 1.5rem);
                    color: transparent;
                    font-size: 2.1875rem;
                    font-weight: bold;
                    text-transform: uppercase;
                    white-space: nowrap;
                    /*@media screen and (max-width: 767px) {
                        font-size: 3.125rem;
                    }*/
                    @media screen and (min-width: 768px) {
                        height: 70px;
                        font-size: 3.125rem;
                    }
                    @media screen and (min-width: 1200px) {
                        margin-left: 1.5rem * $factor-1200;
                        max-width: calc(100% - 1.5em - 1.5rem * #{$factor-1200} - 1.5rem * #{$factor-1200});
                        //font-size: 6.25rem * $factor-1200;
                    }
                    @media screen and (min-width: 1440px) {
                        margin-left: 1.5rem * $factor-1440;
                        max-width: calc(100% - 1.5em - 1.5rem * #{$factor-1440} - 1.5rem * #{$factor-1440});
                        //font-size: 6.25rem * $factor-1440;
                    }
                    @media screen and (min-width: 1920px) {
                        margin-left: 1.5rem * $factor-1920;
                        max-width: calc(100% - 1.5em - 1.5rem * #{$factor-1920} - 1.5rem * #{$factor-1920});
                        //font-size: 6.25rem * $factor-1920;
                    }
                    @media screen and (min-width: 2400px) {
                        margin-left: 1.5rem * $factor-2400;
                        max-width: calc(100% - 1.5em - 1.5rem * #{$factor-2400} - 1.5rem * #{$factor-2400});
                        //font-size: 6.25rem * $factor-2400;
                    }
                }
                .menu-search-input-clone-icon {
                    display: inline-block;
                    width: 1em;
                    height: 42px;
                    vertical-align: bottom;
                    @media screen and (min-width: 768px) {
                        height: 70px;
                    }
                }
            }
        }
        .wrap-body {
            display: flex;
            flex-direction: column;
            .tags {
                margin: -0.25rem 1.5rem;
                @media screen and (max-width: 767px) {
                }
                @media screen and (min-width: 1200px) {
                    width: calc(100% - 7.5rem * #{$factor-1200} - 7.5rem * #{$factor-1200} + 0.25rem * #{$factor-1200} + 0.25rem * #{$factor-1200});
                    margin: -0.25rem * $factor-1200 1.5rem * $factor-1200;
                }
                @media screen and (min-width: 1440px) {
                    width: calc(100% - 7.5rem * #{$factor-1440} - 7.5rem * #{$factor-1440} + 0.25rem * #{$factor-1440} + 0.25rem * #{$factor-1440});
                    margin: -0.25rem * $factor-1440 1.5rem * $factor-1440;
                }
                @media screen and (min-width: 1920px) {
                    width: calc(100% - 7.5rem * #{$factor-1920} - 7.5rem * #{$factor-1920} + 0.25rem * #{$factor-1920} + 0.25rem * #{$factor-1920});
                    margin: -0.25rem * $factor-1920 1.5rem * $factor-1920;
                }
                @media screen and (min-width: 2400px) {
                    width: calc(100% - 7.5rem * #{$factor-2400} - 7.5rem * #{$factor-2400} + 0.25rem * #{$factor-2400} + 0.25rem * #{$factor-2400});
                    margin: -0.25rem * $factor-2400  1.5rem * $factor-2400;
                }
                &.isScrolledIntoView {
                    .tag {
                        opacity: 1;
                        transition: opacity 200ms;
                        @for $i from 1 through 40 {
                            &:nth-child(#{$i}) {
                                transition-delay: #{$i * 100}ms;
                            }
                        }
                    }
                }
                .tag {
                    opacity: 0;
                    transition: opacity 0ms 0ms;
                    will-change: opacity;
                }
            }
        }
    }

    // NOTE: As IE does not show a placeholder for an input with focus, the following styles are used to display a white border
    // below the input on IE only - see: https://stackoverflow.com/questions/14445891/keep-placeholder-on-focus-in-ie10

    _:-ms-lang(x), .menu .menu-search-container .menu-search:after {
        content: '';
        position: absolute;
        left: 1.5rem;
        bottom: -0.75rem;
        width: calc(100% - 1.5em - 1.5rem - 1.5rem);
        border-bottom: 0.25rem solid $color-nochvielvor-white;
        @media screen and (min-width: 1200px) {
            left: 1.5rem * $factor-1200;
            bottom: -0.75rem * $factor-1200;
            width: calc(100% - 1.5em - 1.5rem * #{$factor-1200} - 1.5rem * #{$factor-1200});
            border-bottom: 0.25rem * $factor-1200 solid $color-nochvielvor-white;
        }
        @media screen and (min-width: 1440px) {
            left: 1.5rem * $factor-1440;
            bottom: -0.75rem * $factor-1440;
            width: calc(100% - 1.5em - 1.5rem * #{$factor-1440} - 1.5rem * #{$factor-1440});
            border-bottom: 0.25rem * $factor-1440 solid $color-nochvielvor-white;
        }
        @media screen and (min-width: 1920px) {
            left: 1.5rem * $factor-1920;
            bottom: -0.75rem * $factor-1920;
            width: calc(100% - 1.5em - 1.5rem * #{$factor-1920} - 1.5rem * #{$factor-1920});
            border-bottom: 0.25rem * $factor-1920 solid $color-nochvielvor-white;
        }
        @media screen and (min-width: 2400px) {
            left: 1.5rem * $factor-2400;
            bottom: -0.75rem * $factor-2400;
            width: calc(100% - 1.5em - 1.5rem * #{$factor-2400} - 1.5rem * #{$factor-2400});
            border-bottom: 0.25rem * $factor-2400 solid $color-nochvielvor-white;
        }
    }
</style>
